// extracted by mini-css-extract-plugin
module.exports = {"counterToBadge":"counterToBadge_counterToBadge__Zfm0v","pulsate":"counterToBadge_pulsate__uqOP3"};